// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c47a28d","453":"e76255df","455":"437ed82f","977":"fc8cd1b6"}[chunkId] + ".chunk.js";
};